import _Vue from 'vue';
import ModelRoot from './ModelRoot';

export function ModelRootPlugin(Vue: typeof _Vue, model: ModelRoot): void {
  Vue.prototype.$model = model;
}
